import React from "react";
import "../css/MissionSection.css";

const MissionSection = () => {
  const missionImg = "/images/e.jpeg";

  return (
    <section className="mission-section">
      <div className="mission-container">
        {}
        <div className="mission-text-box">
          <h2 className="mission-heading">Our Mission</h2>
          <div className="mission-description">
            <p>
              Provide quality educational programs that integrate academic, and
              Nepali studies. Promote excellent personal manners, high moral
              values, and strong leadership skills. Prepare students to become
              good citizens and contributing members of society.
            </p>
            <p>
              Empower students to seek and succeed in post-secondary education.
              Guide students to develop life skills and interests.
            </p>
          </div>
        </div>

        {}
        <div className="mission-visual-box">
          <div className="mission-border-frame"></div>
          <img src={missionImg} alt="Our Mission" className="mission-image" />
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
